<template>
  <b-modal id="classOperationsModal"
           size="xl"
           :hideFooter="true"
           centered
  >
    <template #modal-title>
      <h5 v-if="isAddModal">
        <em class="fas fa-plus send-icon"></em> Создание класса
      </h5>
      <h5 v-else>
        <em class="fas fa-edit"></em> Редактирование класса
      </h5>
    </template>
    <template #default>
      <b-form @submit.prevent="onSubmit">
        <b-form-group label="Общая информация"
                      label-cols-lg="3"
                      label-size="lg"
                      label-class="font-weight-bold pt-0"
                      class="mb-0"
        >
          <b-form-group label-for="title_input"
                        label-cols-sm="4"
                        label-cols-lg="3"
                        description=
                          'Пример: МБОУ «СОШ № 1» с углубленным изучением отдельных предметов'
          >
            <template v-slot:label>
              Название: <span class="text-danger">*</span>
            </template>
            <b-form-input
              id="title_input"
              v-model="form.title"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group label-for="year_input"
                        label-cols-sm="4"
                        label-cols-lg="3"
          >
            <template v-slot:label>
              Год основания: <span class="text-danger">*</span>
            </template>
            <b-form-select
              id="year_input"
              v-model="form.year"
              :options="yearsForSelect"
              required
            ></b-form-select>
          </b-form-group>
          <b-form-group label="Сайт: "
                        label-cols-sm="4"
                        label-cols-lg="3"
          >
            <b-form-input
              v-model="form.site"
              type="url"
            ></b-form-input>
          </b-form-group>
          <b-form-group label-for="code_input"
                        label-cols-sm="4"
                        label-cols-lg="3"
                        description="Численный код класса в системе Газпром-олимпиад"
          >
            <template v-slot:label>
              Численный код: <span class="text-danger">*</span>
            </template>
            <b-form-input
              id="code_input"
              v-model="form.olympiad"
              type="number"
              min="1"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group label-for="organization_input"
                        label-cols-sm="4"
                        label-cols-lg="3"
          >
            <template v-slot:label>
              Организация: <span class="text-danger">*</span>
            </template>
            <b-form-select
              id="organization_input"
              v-model="form.organization"
              :options="organizationsForSelect"
              required
            ></b-form-select>
          </b-form-group>
          <b-form-group label-for="statistic_checkbox"
                        label-cols-sm="4"
                        label-cols-lg="3"
          >
            <template v-slot:label>
              Статистика:
            </template>
            <b-form-checkbox
              id="statistic_checkbox"
              v-model="form.isSchool"
            >
              Является школой (для учёта в статистике)
            </b-form-checkbox>
          </b-form-group>
        </b-form-group>
        <b-form-group label="Местоположение"
                      label-cols-lg="3"
                      label-size="lg"
                      label-class="font-weight-bold pt-0"
                      class="mb-0"
        >
          <b-form-group label-for="subject_input"
                        label-cols-sm="4"
                        label-cols-lg="3"
          >
            <template v-slot:label>
              Субъект федерации: <span class="text-danger">*</span>
            </template>
            <b-form-select
              id="subject_input"
              v-model="form.location.region"
              :options="subjectsForSelect"
              required
            ></b-form-select>
          </b-form-group>
          <b-form-group label-for="city_input"
                        label-cols-sm="4"
                        label-cols-lg="3"
                        description="Пример: г. Москва"
          >
            <template v-slot:label>
              Населенный пункт: <span class="text-danger">*</span>
            </template>
            <b-form-input
              id="city_input"
              v-model="form.location.city"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group label-for="federalSubject_input"
                        label-cols-sm="4"
                        label-cols-lg="3"
                        description="Пример: Москва. Подпись на карте нужна для группировки и может отличаться от населённого пункта."
          >
            <template v-slot:label>
              Подпись на карте: <span class="text-danger">*</span>
            </template>
            <b-form-input
              id="federalSubject_input"
              v-model="form.location.federalSubject"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group label-for="address_input"
                        label-cols-sm="4"
                        label-cols-lg="3"
                        description=
                          "Формат ввода: [Почтовый индекс], [Населенный пункт], [Улица, дом]."
          >
            <template v-slot:label>
              Адрес: <span class="text-danger">*</span>
            </template>
            <b-form-input
              id="address_input"
              v-model="form.location.address"
              placeholder=
                "194044, Санкт-Петербург, ул. Смолячкова, дом 6, корпус 1, строение 1"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group label-cols-sm="4"
                        label-cols-lg="3"
                        description=
                          "Пример: 144, 170 (для СПб) или 470, 590 (для Иркутска).
                               Координаты относительно изображения карты. Если Вы хотите расположить
                               в уже созданный маркер, то укажите его координаты, посмотрев их у
                               соответствующей организации"
          >
            <template v-slot:label>
              Координаты: <span class="text-danger">*</span>
            </template>
            <b-form-row>
              <b-col>
                <b-form-input placeholder="Широта"
                              v-model="form.location.latitude"
                              type="number"
                              step="0.0000000000000001"
                />
              </b-col>
              <b-col>
                <b-form-input placeholder="Долгота"
                              v-model="form.location.longitude"
                              type="number"
                              step="0.0000000000000001"
                />
              </b-col>
            </b-form-row>
          </b-form-group>
        </b-form-group>
        <b-button type="submit" variant="primary" style="float: right">
          <div v-if="isAddModal"><em class="fas fa-plus send-icon mr-1"></em> Добавить</div>
          <div v-else><em class="fas fa-save"></em> Сохранить</div>
        </b-button>
      </b-form>
    </template>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex'
import organizationApi from '@/api/organization'
import { subjectsOfRussia } from '@/config/config'
import { regexp } from '@/config/regexp'

export default {
  name: 'ClassOperationsModal',
  data() {
    return {
      yearsForSelect: [{
        text: 'Выберите год основания',
        value: null
      }],
      organizationsForSelect: [{
        text: 'Выберите организацию',
        value: null
      }, 'Отсутствует'],
      subjectsForSelect: [{
        text: 'Выберите субъект',
        value: null
      }],
      form: {
        title: '',
        year: null,
        site: '',
        organization: null,
        olympiad: 1,
        isSchool: false,
        location: {
          region: null,
          federalSubject: '',
          city: '',
          address: '',
          latitude: 0,
          longitude: 0
        }
      },
      id: null,
      addressRegexp: regexp.address,
      oldOlympiadId: null
    }
  },
  props: {
    isAddModal: {
      type: Boolean,
      default() {
        return true
      }
    },
    chosenClass: {
      type: Object,
      default() {
        return {}
      }
    },
    classesOlympiadId: {
      type: Array,
      default() {
        return []
      }
    }
  },
  watch: {
    chosenClass(newVal) {
      if (newVal) {
        const coordinates = newVal.position.split(',')
        this.form.olympiad = newVal.alienSystemDictId
        this.oldOlympiadId = newVal.alienSystemDictId
        this.form.title = newVal.title
        this.form.site = newVal.siteUrl
        this.form.year = newVal.year
        this.form.organization = newVal.org
        this.form.location.federalSubject = newVal.federalSubject
        this.form.location.region = newVal.region
        this.form.location.city = newVal.city
        this.form.isSchool = !newVal.disabledAsSchool
        this.form.location.address = newVal.address
        this.form.location.latitude = +coordinates[0]
        this.form.location.longitude = +coordinates[1]
        this.id = newVal.id
      } else {
        this.form = {
          title: '',
          year: null,
          site: '',
          organization: null,
          isSchool: false,
          olympiad: 1,
          location: {
            region: null,
            federalSubject: '',
            city: '',
            address: '',
            latitude: 0,
            longitude: 0
          }
        }
      }
    }
  },
  mounted() {
    // eslint-disable-next-line no-plusplus
    for (let year = +'2010', current = +(new Date().getFullYear()); year <= current; year++) {
      this.yearsForSelect.push(year)
    }

    organizationApi.getSubdivisions().then(({ data }) => {
      this.organizationsForSelect = data.map((org) => org.title)
    })

    this.subjectsForSelect = Object.keys(subjectsOfRussia).map((key) => ({
      text: subjectsOfRussia[key],
      value: key
    })).sort((val1, val2) => (val1.text > val2.text ? 1 : -1))
  },
  methods: {
    onSubmit() {
      const olympiadId = this.classesOlympiadId.find((id) => id === +this.form.olympiad)
      if (!this.form.location.address.match(this.addressRegexp)) {
        this.pushToasts({
          title: 'Уведомление',
          error: true,
          message: 'Некорректный ввод адреса!'
        })
      } else if (olympiadId && this.oldOlympiadId !== olympiadId) {
        this.pushToasts({
          title: 'Уведомление',
          error: true,
          message: 'Некорректный ввод кода Газпром-олимпиад! Данный код уже зарезервирован в системе!'
        })
      } else if (this.isAddModal) {
        const classForAdd = {
          title: this.form.title,
          org: this.form.organization,
          federalSubject: this.form.location.federalSubject,
          region: this.form.location.region,
          type: 'ГП-класс',
          address: this.form.location.address,
          city: this.form.location.city,
          disabledAsSchool: !this.form.isSchool,
          year: this.form.year,
          siteUrl: this.form.siteUrl,
          position: `${this.form.location.latitude}, ${this.form.location.longitude}`,
          alienSystemDictId: this.olympiad,
          contentObject: {
            title: this.form.title,
            avatar: null,
            type: 'ГП-класс',
            status: 'черновик',
            fullDescription: null,
            shortDescription:
              `<p><strong>Адрес</strong>: ${this.form.location.address} </p>
            <p><strong>Дочернее общество / организация ПАО «Газпром»</strong>: ${this.form.organization}</p>
             <p><strong>Год открытия</strong>: ${this.form.year}</p>`
          }
        }
        organizationApi.addClass(classForAdd)
          .then(() => {
            this.pushToasts({
              title: 'Уведомление',
              message: 'Класс успешно создан.'
            })
            this.$bvModal.hide('classOperationsModal')
            this.$emit('classOperationCompleted')
          })
          .catch(() => {
            this.pushToasts({
              title: 'Уведомление',
              error: true,
              message: 'Ошибка создания класса. '
            })
          })
      } else {
        const classForEdit = {
          id: this.id,
          title: this.form.title,
          org: this.form.organization,
          federalSubject: this.form.location.federalSubject,
          region: this.form.location.region,
          address: this.form.location.address,
          disabledAsSchool: !this.form.isSchool,
          city: this.form.location.city,
          year: this.form.year,
          siteUrl: this.form.site,
          position: `${this.form.location.latitude}, ${this.form.location.longitude}`,
          alienSystemDictId: this.form.olympiad
        }
        console.log(classForEdit)
        organizationApi.editOrganization(classForEdit)
          .then(() => {
            this.pushToasts({
              title: 'Уведомление',
              message: 'Класс успешно отредактирован.'
            })
            this.$bvModal.hide('classOperationsModal')
            this.$emit('classOperationCompleted')
          })
          .catch(() => {
            this.pushToasts({
              title: 'Уведомление',
              error: true,
              message: 'Ошибка редактирования класса. '
            })
          })
      }
    },
    ...mapActions({
      pushToasts: 'toasts/pushToasts'
    })
  }
}
</script>

<style scoped>
textarea:focus,
textarea:not(focus),
textarea:active {
  outline: none !important;
  box-shadow: none !important;
  border: 1px lightgrey solid !important;
}
</style>
